export default __webpack_public_path__ + "static/media/pdf.fc87771a.svg";